import React from 'react';
import classnames from 'classnames';
import Item from './Item';
import * as styles from './base.scss';
export default class Accordion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: null,
        };
    }
    toggle(item) {
        this.setState({ open: item !== this.state.open ? item : null });
    }
    render() {
        return (this.props.children && (React.createElement("div", { className: classnames(styles.base, this.props.className) }, React.Children.map(this.props.children, child => {
            if (React.isValidElement(child) && child.type === Item) {
                return React.cloneElement(child, {
                    open: this.state.open,
                    toggle: (item) => this.toggle(item),
                });
            }
        }))));
    }
}
